@if (!isUnlocked) {
  <div class="results-screen" style="padding-top: var(--space-3xl);">
    <div class="results-screen__icon results-screen__icon--failed">
      <span [innerHTML]="Icons.lock | safeHtml"></span>
    </div>
    <h2>{{ 'Training_Learner.Certificate_Locked' | translate }}</h2>
    <p class="results-screen__message">
      {{ ('Training_Learner.Certificate_Locked_Detail' | translate).replace('%s', totalModules).replace('%c', completedCount) }}
    </p>
    <button class="btn btn--primary" (click)="navigate('/overview')">{{ 'Training_Learner.Continue_Training' | translate }}</button>
  </div>
} @else {
  <div class="certificate-screen">
    <h2 style="margin-bottom: var(--space-sm);">{{ 'Training_Learner.Your_Certificate' | translate }}</h2>
    <p style="color: var(--gray-500); margin-bottom: var(--space-lg);">{{ 'Training_Learner.Congrats_Programme' | translate }}</p>

    <div class="certificate" id="certificate-content">
      <a id="headerLogoSiffi" href="javascript:void(0);" class="c-header__logo c-logo c-logo--siffi-green certificate__logo"></a>
      <p class="certificate__accent">{{ 'Training_Learner.Certificate_Of_Completion' | translate }}</p>
      <h2 class="certificate__title">{{ programme?.title || programmeTitle }}</h2>

      <p style="color: var(--gray-500); margin-bottom: var(--space-sm);">{{ 'Training_Learner.Certify_That' | translate }}</p>
      <p class="certificate__recipient">{{ learnerName }}</p>
      <p class="certificate__org">{{ organizationName }}</p>

      <p class="certificate__programme">
        {{ ('Training_Learner.Cert_Paragraph' | translate).replace('%s', totalModules).replace('%t', (programme?.title || programmeTitle)) }}
      </p>

      <div class="certificate__details">
        <div>
          <p class="certificate__detail-label">{{ 'Training_Learner.Date_Of_Completion' | translate }}</p>
          <p class="certificate__detail-value">{{ completedDate }}</p>
        </div>
        <div>
          <p class="certificate__detail-label">{{ 'Training_Learner.Certificate_ID' | translate }}</p>
          <p class="certificate__detail-value">{{ certificateId }}</p>
        </div>
        <div>
          <p class="certificate__detail-label">{{ 'Training_Learner.Average_Score' | translate }}</p>
          <p class="certificate__detail-value">{{ averageScore }}%</p>
        </div>
      </div>
    </div>

    <div class="certificate-actions">
      <button class="btn btn--primary" (click)="printCertificate()">
        <span [innerHTML]="Icons.download | safeHtml"></span> {{ 'Training_Learner.Print_Save' | translate }}
      </button>
      <button class="btn btn--secondary" (click)="navigate('/overview')">
        {{ 'Training_Learner.Back_To_Programme' | translate }}
      </button>
    </div>

    <p style="font-size: 0.8125rem; color: var(--gray-400); margin-top: var(--space-lg);">
      {{ 'Training_Learner.Print_Instructions' | translate }}
    </p>
  </div>
}
